import { useState } from "react";
import { CrearEntidadForm, Input } from "@/components/ui";
import { toastError } from "@/lib/toast";
import type { CrearItemCatalogoInput } from "../services/catalogos-contables-admin-service";

export interface CrearFormCopy {
  titulo: string;
  ejemploCodigo: string;
  ejemploNombre: string;
}

/**
 * Form de creación reutilizado por CeCo y Cuenta. Recibe textos por
 * prop (`copy`) y la mutation handler · agnóstico de la entidad.
 */
export function ItemCatalogoCrearForm({
  copy,
  loading,
  onCrear,
  onCancelar,
}: {
  copy: CrearFormCopy;
  loading: boolean;
  onCrear: (input: CrearItemCatalogoInput) => void;
  onCancelar: () => void;
}) {
  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");

  const submit = () => {
    if (!codigo.trim() || !nombre.trim()) {
      toastError({ title: "Datos incompletos", message: "Código y nombre son obligatorios." });
      return;
    }
    onCrear({ codigo: codigo.trim(), nombre: nombre.trim() });
  };

  return (
    <CrearEntidadForm titulo={copy.titulo} descripcion="El código funcional es inmutable tras la creación." onCancelar={onCancelar} onCrear={submit} creando={loading}>
      <Input label="Código" placeholder={copy.ejemploCodigo} value={codigo} onChange={(e) => setCodigo(e.currentTarget.value)} className="font-mono" required />
      <Input label="Nombre" placeholder={copy.ejemploNombre} value={nombre} onChange={(e) => setNombre(e.currentTarget.value)} required />
    </CrearEntidadForm>
  );
}
